import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { DEFAULT_PAGE_SIZE } from '../components/constants';
import { getArtists } from '../lib/artists';

interface ArtistQueryProps {
  searchText?: string;
  labelIds: number[];
  isCrossover: boolean;
  isOnRoster?: boolean;
  pageNumber: number;
}

export function useArtistQuery({
  searchText,
  labelIds,
  isCrossover,
  isOnRoster,
  pageNumber,
}: ArtistQueryProps) {
  return useQuery({
    queryKey: [
      'artist-roster',
      searchText,
      labelIds,
      isCrossover,
      isOnRoster,
      pageNumber,
    ],
    queryFn: ({ signal }) => {
      return getArtists({
        offset: (pageNumber - 1) * DEFAULT_PAGE_SIZE,
        limit: DEFAULT_PAGE_SIZE,
        search: searchText,
        labels: labelIds,
        isCrossover,
        isOnRoster,
        signal,
      });
    },
    placeholderData: keepPreviousData,
    // @TODO WMG1-429 - Move this to the global QueryClient config options
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
